import {
  DisplayableError,
  getCauses,
} from "kreate-common/modules/displayable-error";
import { useModalPromises } from "kreate-common/modules/kreate-ui/components/Modal/hoc/withModalPromises";

import ModalFailure from ".";

export function useModalTrigger$ModalFailure() {
  const { showModal } = useModalPromises();

  const openModal = async (
    otherProps?: Partial<
      Omit<React.ComponentProps<typeof ModalFailure>, "open" | "onClose">
    >
  ) =>
    await showModal<void>(({ resolve }) => (
      <ModalFailure open={true} onClose={resolve} {...otherProps} />
    ));

  const openModalWithError = async (error: unknown) => {
    const displayableError = DisplayableError.from(error);
    const { title, description } = displayableError || {};
    const causes = getCauses(displayableError);
    await showModal<void>(({ resolve }) => (
      <ModalFailure
        open={true}
        onClose={resolve}
        title={title}
        description={description}
        debug={causes ? { causes } : undefined}
      />
    ));
  };

  return { openModal, openModalWithError };
}
